var GOOGLEMAPS = (function() {
  function buildMap() {
    const mapElement = document.getElementById("google-maps");

    const lat = parseFloat(mapElement.dataset.lat);
    const lng = parseFloat(mapElement.dataset.lng);
    const location = { lat: lat, lng: lng };

    const map = new google.maps.Map(mapElement, {
      center: location,
      zoom: 14,
    });

    const marker = new google.maps.Marker({
      position: location,
      map: map,
    });
  }

  function init() {
    buildMap();
  }

  return {
    init: init,
  };
})();
